import { atom } from 'recoil';

// 사이드 박스 모달
export const SideMenuBoxRecoil = atom<boolean>({
  key: 'SideMenuBoxRecoil',
  default: false,
});

// 에러 모달
export const errorModalTextRecoil = atom<string>({
  key: 'errorModalTextRecoil',
  default: '',
});

// 완료 모달
export const completeModalRecoil = atom<boolean>({
  key: 'completeModalRecoil',
  default: false,
});

// 수정 모달
export const modifyModalRecoil = atom<boolean>({
  key: 'modifyModalRecoil',
  default: false,
});

// 삭제 모달
export const deleteModalRecoil = atom<boolean>({
  key: 'deleteModalRecoil',
  default: false,
});

// 출입관리 상세 모달
export const entryDailyDetailModalRecoil = atom<boolean>({
  key: 'entryDailyDetailModalRecoil',
  default: false,
});

// 주소 모달
export const addressModalRecoil = atom<boolean>({
  key: 'addressModalRecoil',
  default: false,
});

// 출입장소 등록 모달
export const placeAddModalRecoil = atom<boolean>({
  key: 'placeAddModalRecoil',
  default: false,
});

// 출입장소 수정 모달
export const placeModifyModalRecoil = atom<boolean>({
  key: 'placeModifyModalRecoil',
  default: false,
});

// 출입신분증 등록 모달
export const idCardAddModalRecoil = atom<boolean>({
  key: 'idCardAddModalRecoil',
  default: false,
});

// 출입신분증 수정 모달
export const idCardModifyModalRecoil = atom<boolean>({
  key: 'idCardModifyModalRecoil',
  default: false,
});
